// extracted by mini-css-extract-plugin
export default {"header":"RC","light":"SC","dark":"TC","headertitle":"UC","fname":"VC","headerContent":"WC","right":"XC","descriptionwrapper":"YC","appear":"ZC","second":"aE","third":"bE","forth":"cE"};
    if(module.hot) {
      // 1713211524574
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  